export const zIndex = {
  base: 0,
  sticky: 10,
  nav: 20,
  dropdown: 30,
  overlay: 40,
  dialog: 50,
  toast: 60,
  tooltip: 70,
} as const;
